/**
 * Rolagem lembrada por URL.
 *
 * O scroll NÃO é o da janela: é o do `<main overflow-y-auto>` do AppLayout, e o
 * AppLayout remonta a cada rota (cada `<Route>` do App.tsx monta o seu). O
 * navegador não tem como restaurar isso sozinho — sem esta peça, "Voltar"
 * devolve a lista certa, com os filtros certos, mas no topo, e em Colheitas com
 * 25 linhas por página isso ainda é "achar de novo".
 *
 * Só restaura em `popstate` (voltar/avançar). Navegação PARA FRENTE começa no
 * topo, como hoje.
 */
const LIMITE = 50;
const rolagemPorUrl = new Map<string, number>();
let ultimaNavegacaoFoiPop = false;

if (typeof window !== "undefined") {
  window.addEventListener("popstate", () => {
    ultimaNavegacaoFoiPop = true;
  });
  // Navegação PARA FRENTE limpa a intenção. Sem isto a marca de um `popstate`
  // sobrevive quando a rota de destino não monta o AppLayout (uma tela pública,
  // por exemplo) e restauraria a rolagem na próxima navegação para frente que
  // caísse numa URL com posição guardada. O Wouter monkey-patcha `pushState`/
  // `replaceState` e dispara estes eventos (use-browser-location.js).
  for (const tipo of ["pushState", "replaceState"]) {
    window.addEventListener(tipo, () => {
      ultimaNavegacaoFoiPop = false;
    });
  }
}

export function gravarRolagem(url: string, topo: number): void {
  // Map preserva ordem de inserção: re-inserir joga a URL para o fim, e a
  // descartada é sempre a mais antiga. É sessão, não precisa persistir.
  if (rolagemPorUrl.has(url)) rolagemPorUrl.delete(url);
  rolagemPorUrl.set(url, topo);
  if (rolagemPorUrl.size > LIMITE) {
    const maisAntiga = rolagemPorUrl.keys().next();
    if (!maisAntiga.done) rolagemPorUrl.delete(maisAntiga.value);
  }
}

/** Consome a intenção de restaurar: devolve a posição só se a navegação foi um pop. */
export function consumirRolagem(url: string): number | undefined {
  const foiPop = ultimaNavegacaoFoiPop;
  ultimaNavegacaoFoiPop = false;
  return foiPop ? rolagemPorUrl.get(url) : undefined;
}

/** Só para teste — o Map é de módulo e sobrevive entre casos. */
export function _resetarRolagem(): void {
  rolagemPorUrl.clear();
  ultimaNavegacaoFoiPop = false;
}

/** Só para teste — simula o `popstate` sem DOM. */
export function _marcarPop(): void {
  ultimaNavegacaoFoiPop = true;
}

/** Só para teste — simula o `pushState`/`replaceState` sem DOM. */
export function _marcarNavegacaoParaFrente(): void {
  ultimaNavegacaoFoiPop = false;
}
